import { useEffect } from "react";

export default function useActivityInfiniteScroll({ rootRef, sentinelRef, enabled, loading, onLoadMore }) {
  useEffect(() => {
    const root = rootRef.current;
    const sentinel = sentinelRef.current;
    if (!enabled || loading || !root || !sentinel || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) onLoadMore();
    }, { root, rootMargin: "0px 0px 360px 0px", threshold: 0 });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [rootRef, sentinelRef, enabled, loading, onLoadMore]);
}
